import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";

import Login from "@/pages/Login";
import DashboardLayout from "@/pages/DashboardLayout";
import DashboardHome from "@/pages/DashboardHome";
import Conversations from "@/pages/Conversations";
import Templates from "@/pages/Templates";
import TemplateCreate from "@/pages/TemplateCreate";
import Staff from "@/pages/Staff";
import PrivateNumbers from "@/pages/PrivateNumbers";
import BotPage from "@/pages/Bot";
import ApiKeys from "@/pages/ApiKeys";
import Settings from "@/pages/Settings";

// Sends staff straight to Conversations on landing at "/".
function RoleHome() {
  const { user } = useAuth();
  if (user?.role === "staff") return <Navigate to="/conversations" replace />;
  return <DashboardHome />;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute staffAllowed>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<RoleHome />} />
              <Route
                path="conversations"
                element={
                  <ProtectedRoute staffAllowed>
                    <Conversations />
                  </ProtectedRoute>
                }
              />
              <Route
                path="templates"
                element={
                  <ProtectedRoute adminOnly>
                    <Templates />
                  </ProtectedRoute>
                }
              />
              <Route
                path="templates/new"
                element={
                  <ProtectedRoute adminOnly>
                    <TemplateCreate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="templates/edit/:name"
                element={
                  <ProtectedRoute adminOnly>
                    <TemplateCreate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="staff"
                element={
                  <ProtectedRoute adminOnly>
                    <Staff />
                  </ProtectedRoute>
                }
              />
              <Route
                path="private-numbers"
                element={
                  <ProtectedRoute adminOnly>
                    <PrivateNumbers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="bot"
                element={
                  <ProtectedRoute adminOnly>
                    <BotPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="keys"
                element={
                  <ProtectedRoute adminOnly>
                    <ApiKeys />
                  </ProtectedRoute>
                }
              />
              <Route
                path="settings"
                element={
                  <ProtectedRoute adminOnly>
                    <Settings />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}
